import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface StepperState {
  currentStep: number; // 0 = Basic, 1 = Category, 2 = Pricing
  completedSteps: boolean[]; // [true, true, false] means first two steps done
}

const initialState: StepperState = {
  currentStep: 0,
  completedSteps: [false, false, false],
};

const stepperSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setStepCompleted(state, action: PayloadAction<number>) {
      state.completedSteps[action.payload] = true;
    },
    clearStepCompleted(state, action: PayloadAction<number>) {
      const idx = action.payload;
      if (idx < 0 || idx >= state.completedSteps.length) {
        return;
      }
      for (let i = idx; i < state.completedSteps.length; i++) {
        state.completedSteps[i] = false;
      }
    },
    setCompletedSteps(state, action: PayloadAction<boolean[]>) {
      state.completedSteps = action.payload;
    },
    resetStepper(state) {
      state.currentStep = 0;
      state.completedSteps = [false, false, false];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  }
});

export const { setCurrentStep, setStepCompleted, clearStepCompleted, setCompletedSteps, resetStepper } = stepperSlice.actions;
export default stepperSlice.reducer; 